import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface MyTimesheetSummaryCardProps {
  dailySums: number | string;
}

export const MyTimesheetSummaryCard = ({
  dailySums,
}: MyTimesheetSummaryCardProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box
      padding="12px 16px"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      style={{
        height: "100%",
        backgroundColor: theme.palette.greenBase.main,
        borderRadius: "4px",
      }}
    >
      <Typography variant="body1" style={{ color: theme.palette.white.main }}>
        {t("MY_TIMESHEET_DAILY_TOTAL")}
      </Typography>
      <Typography variant="h4" style={{ color: theme.palette.white.main }}>
        {dailySums}
      </Typography>
    </Box>
  );
};

export default MyTimesheetSummaryCard;
